import { render, staticRenderFns } from "./ZDMFailures.vue?vue&type=template&id=799b4edd&scoped=true&"
import script from "./ZDMFailures.vue?vue&type=script&lang=js&"
export * from "./ZDMFailures.vue?vue&type=script&lang=js&"
import style0 from "./ZDMFailures.vue?vue&type=style&index=0&id=799b4edd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799b4edd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VIcon,VList,VListItem,VListItemContent,VRow,VTextField})
